exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.matrix{border-collapse:collapse}table.matrix td,table.matrix th{border:1px #333 solid}", ""]);

// exports
